import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';

import logoCarrefour from "../../assets/images/logo.png";
import logoAtacadao from "../../assets/images/atacadao-logo.png";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import { Logo } from "../../components/design/layout/logo";

import UserTerms from '../../services/UserTerms';
import Swal from 'sweetalert2';

import {
    Wrapper,
    Header,
    HeaderContent,
    WrapLogo,
    IconDescription,
    IconWrapper,
    WrapInfo,
    TermsTitle,
    TermsDate,
    Content,
    ContentBlock,
} from './styles';

function TermsReadOnly({ website }) {

    const history = useHistory();
    const [termInformation, setTermInformation] = useState();

    const checkUserTerm = React.useCallback(async () => {
        const userTerms = new UserTerms();

        const userTermsResponse = await userTerms.checkUserTerms(true)
            .catch((error) => userTerms.formatErrorMessage(error.response, 'UTLT'));

        if (userTermsResponse && userTermsResponse.data && userTermsResponse.data.type === 'success') {
            setTermInformation(userTermsResponse.data.payload);

        } else {
            Swal.fire(userTermsResponse.data.title, userTermsResponse.data.message, userTermsResponse.data.type);
        }
    }, []);

    useEffect(() => {
        checkUserTerm();
    }, [checkUserTerm]);

    const handleHistory = () => {
        history.goBack();
        return history.goBack();
    };

    const justifyContent = {
        'space-between': "space-between",
        center: "center",
        start: "start",
        end: "end",
    }

    return (
        <>
            <Wrapper>
                <Header>
                    <HeaderContent>
                        <WrapLogo flexPosition={justifyContent['center']}>
                            <Logo link="/" image={website === "atacadao" ? logoAtacadao : logoCarrefour} alt="Carrefour" />
                        </WrapLogo>
                        <IconDescription>
                            <IconWrapper
                                iconBg={website === "carrefour" ? '#e7edfa' : '#26620014'}
                                iconColor={website === "carrefour" ? '#1E5BC6' : '#266200'}
                                className={'go-back'}
                                onClick={handleHistory}
                            >
                                <Icon icon={["far", "chevron-left"]} />
                            </IconWrapper>
                            <WrapInfo>
                                <TermsTitle>Termos e condições</TermsTitle>
                                <TermsDate>Ultima Atualização: {termInformation?.lastUpdate}</TermsDate>
                            </WrapInfo>
                        </IconDescription>
                    </HeaderContent>
                </Header>

                <Content>
                    <ContentBlock dangerouslySetInnerHTML={{ __html: termInformation?.term }}></ContentBlock>
                </Content>

            </Wrapper>
        </>
    )
};

const mapStateToProps = (state) => ({
    website: state.websiteReducer.website
})

export default withRouter(connect(mapStateToProps, {})(TermsReadOnly));
